export { StampPreview } from '../../shared/StampPreview'